import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable()
export class AuthGuard  {

    constructor(private jwtHelper: JwtHelperService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        var token = localStorage.getItem("access_token");

        if (token && !this.jwtHelper.isTokenExpired(token))
            return true;

        this.router.navigate(['login'], { queryParams: { returnUrl: state.url } });

        return false;
    }
}